export const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const containsVariable = (text: string, variable: string): boolean => {
  if (!text) return false;
  const content = text.trim();
  if (!content) return false;
  const singleBraces = new RegExp(`\\{${escapeRegExp(variable)}\\}`, 'i');
  const doubleBraces = new RegExp(`\\{\\{\\s*${escapeRegExp(variable)}\\s*\\}\\}`, 'i');
  return singleBraces.test(content) || doubleBraces.test(content);
};

const escapeHtml = (value: string): string =>
  value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

export const buildHighlightHTML = (text: string, variables: string[]): string => {
  if (!text) {
    return '';
  }

  const meaningfulVariables = variables.filter(Boolean);
  if (meaningfulVariables.length === 0) {
    return escapeHtml(text);
  }

  const alternation = meaningfulVariables.map(escapeRegExp).join('|');
  if (!alternation) {
    return escapeHtml(text);
  }

  const pattern = new RegExp(`(\\{\\{\\s*(?:${alternation})\\s*\\}\\}|\\{(?:${alternation})\\})`, 'gi');
  let lastIndex = 0;
  let output = '';
  let match: RegExpExecArray | null;

  while ((match = pattern.exec(text)) !== null) {
    const [fullMatch] = match;
    const start = match.index;
    const end = start + fullMatch.length;

    output += escapeHtml(text.slice(lastIndex, start));
    output += `<mark class="bg-green-700/40 text-green-100 rounded-sm px-0.5">${escapeHtml(fullMatch)}</mark>`;
    lastIndex = end;
  }

  output += escapeHtml(text.slice(lastIndex));
  return output || '&nbsp;';
};
